import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { ProgressBar } from './ProgressBar';
import type { Stage } from '../../data/roadmapContent';
interface StepShellProps {
  step: number;
  total: number;
  stage: Stage;
  question: string;
  /** One short plain-English line. Never a form label. */
  note?: string;
  children: React.ReactNode;
  onBack: () => void;
  /** Omitted on screens that advance themselves, such as choice questions. */
  onNext?: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
}
export function StepShell({
  step,
  total,
  stage,
  question,
  note,
  children,
  onBack,
  onNext,
  nextLabel = 'Continue',
  nextDisabled = false
}: StepShellProps) {
  return <div className="w-full" data-id="element-453" data-mp="28oblgmzfetqc">
      <ProgressBar step={step} total={total} stage={stage} data-id="element-454" data-mp="28njpvc5tww02" />

      <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900 dark:text-white leading-[1.2]" data-id="element-455" data-mp="t8com7v9ek5e">
        {question}
      </h1>

      {note && <p className="mt-3 text-base text-slate-600 dark:text-slate-400 leading-relaxed" data-id="element-456" data-mp="3812rmfpnaxmo">
          {note}
        </p>}

      <div className="mt-8" data-id="element-457" data-mp="332t14iev8l7e">{children}</div>

      <div className="mt-10 flex items-center gap-3" data-id="element-458" data-mp="33443qewkrmwx">
        <button type="button" onClick={onBack} className="inline-flex items-center gap-2 px-5 py-4 rounded-xl border border-slate-200 dark:border-white/10 text-base font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-white/5 transition-colors" data-id="element-459" data-mp="3h20yr6vdrl9h">
          <ArrowLeftIcon className="w-5 h-5" data-id="element-460" data-mp="3m02izv4jlqmj" />
          Back
        </button>

        {onNext && <button type="button" onClick={onNext} disabled={nextDisabled} className="flex-1 inline-flex items-center justify-center gap-2 px-6 py-4 rounded-xl bg-gradient-to-r from-accent-500 to-primary-500 text-white text-lg font-semibold transition-[transform,box-shadow,opacity] duration-200 ease-out hover:shadow-[0_0_30px_rgba(20,184,166,0.35)] hover:scale-[1.01] disabled:opacity-40 disabled:hover:scale-100 disabled:hover:shadow-none disabled:cursor-not-allowed group" data-id="element-461" data-mp="4j2kt3vtsyan">
            {nextLabel}
            <ArrowRightIcon className="w-5 h-5 transition-transform duration-200 ease-out group-enabled:group-hover:translate-x-1" data-id="element-462" data-mp="3bevn08c3kwoh" />
          </button>}
      </div>
    </div>;
}